export const PolicyCancellationSubmissionReasonValue = {
  EXTERNAL_EVENT: 'EXTERNAL_EVENT',
  TECHNICAL_ISSUE: 'TECHNICAL_ISSUE',
  AGENT_ERROR: 'AGENT_ERROR',
};

const path = 'POLICY_CANCELLATION.submissionReason';

export const policyCancellationSubmissionReasons = [
  {
    value: PolicyCancellationSubmissionReasonValue.EXTERNAL_EVENT,
    label: `${path}.externalEvent`,
    examples: `${path}.externalEventExamples`,
  },
  {
    value: PolicyCancellationSubmissionReasonValue.TECHNICAL_ISSUE,
    label: `${path}.technicalIssue`,
    examples: `${path}.technicalIssueExamples`,
  },
  {
    value: PolicyCancellationSubmissionReasonValue.AGENT_ERROR,
    label: `${path}.agentError`,
    examples: `${path}.agentErrorExamples`,
  },
];
